import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { kbBrakeAppService } from 'src/app/services/feature/kb-brakeApplication/KbBrakeApplication.service';
import { adminsearchCommentPopup } from './adminSearchCommentPopup.component';
import { Router } from '@angular/router';
import { KbExportToXlsxService } from 'src/app/services/feature/ExportCsv/kb-export-csv.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-brake-admin-search-form',
  templateUrl: './brake-admin-search-form.component.html',
  styleUrls: ['./brake-admin-search-form.component.scss'],
  standalone: false
})
export class BrakeAdminSearchFormComponent {
  BrakeRequests: any;
  apiloaded: boolean = false;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID


  isMobile: boolean = false;
  sub = new Subscription();
  // creating variables forsorting the table with arrows
  sortByDateCreated: string = undefined;
  sortByStatus: string = undefined;
  ascending: string = 'asc';
  descending: string = 'desc';
  //A two way binded search String
  query: string = '';
  platformId = inject(PLATFORM_ID);
  constructor(private breakpointObserver: BreakpointObserver,
    private service: kbBrakeAppService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private kbfile: KbExportToXlsxService) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  ngOnInit() {
    if (this.isMobile) {
      this.setCustomWidth();

    }
    this.sortByDateCreated = this.descending;
    this.getBrakeRequests(0, this.descending);
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }

  openComments(comments: any) {
    this.dialog.open(adminsearchCommentPopup, { data: comments });
  }

  getBrakeRequests(page?, sort?) {
    this.sub.add(this.service.adminbrakeAppSlp(this.query, page, sort).subscribe((res: any) => {
      if (res?.message?.status == 'SUCCESS') {
        this.BrakeRequests = res;
        this.apiloaded = true;
        this.cdr.detectChanges();
      }
    }))
  }
  postCall() {
    this.getBrakeRequests(0);
  }

  editUser(code) {
    this.router.navigate(['bendixADBAdminCommentPage'], {
      queryParams: { code: code },
    });
  }

  changePageCustom(e) {
    this.getBrakeRequests(e, '');
  }

  sort(type) {
    if (type == 'byStatus') {
      if (this.sortByStatus == this.ascending) {
        this.sortByStatus = this.descending;
      } else if (this.sortByStatus == this.descending) {
        this.sortByStatus = this.ascending;
      } else {
        this.sortByStatus = this.descending;
      }
      this.removeOtherSorts(type, this.sortByStatus);
    }

    else if (type == 'byCreationDate') {
      if (this.sortByDateCreated == this.ascending) {
        this.sortByDateCreated = this.descending;
      } else if (this.sortByDateCreated == this.descending) {
        this.sortByDateCreated = this.ascending;
      } else {
        this.sortByDateCreated = this.descending;
      }
      this.removeOtherSorts(type, this.sortByDateCreated);
    }
  }

  removeOtherSorts(type, format) {
    if (type == 'byStatus') {
      this.sortByDateCreated = undefined;
    } else if (type == 'byCreationDate') {
      this.sortByStatus = undefined;
    }
    let payload;
    if (format == this.descending) {
      payload = { type: type + format };
    } else {
      payload = { type: type };
    }
    this.getBrakeRequests(0, payload.type);
  }


  downloadZip(byteArray: any, name: string) {
    try {
      const decodedByteArray = atob(byteArray);
      const zipArray = new Uint8Array(decodedByteArray.length);
      for (let i = 0; i < decodedByteArray.length; i++) {
        zipArray[i] = decodedByteArray.charCodeAt(i);
      }
      if (isPlatformBrowser(this.platformId)) {
        const zipBlob = new Blob([zipArray], { type: 'application/zip' });
        const zipUrl = window.URL.createObjectURL(zipBlob);

        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = name + '.zip';
        link.click();

        this.cleanupDownloadUrl(zipUrl);
      }
    } catch (error) {
      console.error('Error downloading ZIP file:', error);
    }
  }

  private cleanupDownloadUrl(url: string) {
    if (isPlatformBrowser(this.platformId)) {

      this.timeout = setTimeout(() => window.URL.revokeObjectURL(url), 0);
    }
  }
  exportDataToExcel() {
    this.sub.add(this.service.adminBrakeAppExportExcel().subscribe((xyz: any) => {
      this.kbfile.exportwithBoldHeader(xyz?.data, 'Brake_Applications.xlsx');
    }));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
